// extracted by mini-css-extract-plugin
export default {"header":"DefaultModalHeader_header__cEGFj","close":"DefaultModalHeader_close__Ulwv1","defaultPadding":"DefaultModalHeader_defaultPadding__kv2dY"};